// extracted by mini-css-extract-plugin
export default {"image":"FormHeader_image__gyh75"};